import SelectField from 'components/Inputs/SelectField/SelectFieldChannel';
import { SelectFieldProps } from 'containers/ChannelManagement/Branch/BranchForm/Address/types';
import { useMemo } from 'react';
import { useRegionQuery } from 'utils/queries/location';

export type RegionSelectProps = {
	selectFieldProps?: SelectFieldProps;
};

const RegionSelect: React.FC<RegionSelectProps> = ({ selectFieldProps }) => {
	const { data, isLoading } = useRegionQuery();
	const options = useMemo(
		() =>
			data?.map(({ id: value, name: label }) => ({
				label,
				value,
			})) || [],

		[data]
	);

	return (
		<SelectField
			label="Region"
			isLoading={isLoading}
			options={options}
			{...selectFieldProps}
		/>
	);
};

export default RegionSelect;
